module.exports = __webpack_public_path__ + "img/pawn-shop.1de45809.png";